import { Box } from "@chakra-ui/react"

export const EmptyCell = () => {
  return (
    <Box color="gray.400">
      Нет данных
    </Box>
  )
}
